import { defineMessages } from 'react-intl';

export default defineMessages({
  newPhoneNumberlLabel: {
    id: 'features.changePhoneNumber.newPhoneNumberlLabel',
    defaultMessage: 'Inserisci nuovo numero di cellulare',
    description: 'Label shown above the new phone number input field',
  },
  secondaryPhoneNumberlLabel: {
    id: 'features.changePhoneNumber.secondaryPhoneNumberlLabel',
    defaultMessage: 'Inserisci numero di cellulare secondario',
    description: 'Label shown above the new phone number input field',
  },
  newPhoneNumberlPlaceholder: {
    id: 'features.changePhoneNumber.newPhoneNumberlPlaceholder',
    defaultMessage: 'Numero di cellulare',
    description: 'Placeholder of the new phone number input field',
  },
  confirmNewPhoneNumberlLabel: {
    id: 'features.changePhoneNumber.confirmNewPhoneNumberlLabel',
    defaultMessage: 'Conferma nuovo numero di cellulare',
    description:
      'Label shown above the confirmation new phone number input field',
  },
  confirmSecondaryPhoneNumberlLabel: {
    id: 'features.changePhoneNumber.confirmNewPhoneNumberlLabel',
    defaultMessage: 'Conferma numero di cellulare secondario',
    description:
      'Label shown above the confirmation new phone number input field',
  },
  confirmNewPhoneNumberlPlaceholder: {
    id: 'features.changePhoneNumber.confirmNewPhoneNumberlPlaceholder',
    defaultMessage: 'Numero di cellulare',
    description: 'Placeholder of the confirmation new phone number input field',
  },
  changePhoneNumberGoOnButton: {
    id: 'features.changePhoneNumber.changePhoneNumberGoOnButton',
    defaultMessage: 'Avanti',
    description: 'Label of the change phone number button',
  },
  newPhoneNumberlLabelDisabled: {
    id: 'features.changePhoneNumber.newPhoneNumberlLabelDisabled',
    defaultMessage: 'Nuovo numero di cellulare',
    description: 'Label shown above the new phone number input field disabled',
  },
  labelChangePhoneNumberVerificationCode: {
    id: 'features.changePhoneNumber.labelChangePhoneNumberVerificationCode',
    defaultMessage: 'Codice di verifica',
    description: 'Label shown above the verification input field',
  },
  placeholderChangePhoneNumberVerificationCode: {
    id: 'features.changePhoneNumber.placeholderChangePhoneNumberVerificationCode',
    defaultMessage: 'Inserisci il tuo codice di verifica',
    description: 'Placeholder of the verification code input field',
  },
  labelChangePhoneNumberVerificationCodeEmail: {
    id: 'features.changePhoneNumber.labelChangePhoneNumberVerificationCodeEmail',
    defaultMessage:
      'Inserisci il codice che è stato inviato all’indirizzo email scelto.',
    description: 'Label shown above the verification input field',
  },
  placeholderChangePhoneNumberVerificationCodeEmail: {
    id: 'features.changePhoneNumber.placeholderChangePhoneNumberVerificationCodeEmail',
    defaultMessage: 'Inserisci il tuo codice di verifica email',
    description: 'Placeholder of the verification code input field',
  },
  labelChangePhoneNumberVerificationCodePhoneNumber: {
    id: 'features.changePhoneNumber.labelChangePhoneNumberVerificationCodePhoneNumber',
    defaultMessage:
      'Inserisci il codice che è stato inviato al numero di cellulare',
    description: 'Placeholder of the verification code input field',
  },
  placeholderChangePhoneNumberVerificationCodePhoneNumber: {
    id: 'features.changePhoneNumber.placeholderChangePhoneNumberVerificationCodePhoneNumber',
    defaultMessage: 'Inserisci il tuo codice di verifica numero di cellulare',
    description: 'Placeholder of the verification code input field',
  },
  //placeholderChangePhoneNumberVerificationCode: {
  //  id: 'features.changePhoneNumber.desclaimerVerificationOtp',
  //  defaultMessage: 'Inserisci il tuo codice di verifica numero di cellulare',
  //  description: 'Placeholder of the verification code input field',
  // },
  desclaimerVerificationOtp: {
    id: 'features.changePhoneNumber.desclaimerVerificationOtp',
    defaultMessage:
      'Inserisci i codici che sono stati inviati all’indirizzo email e al numero di cellulare. In caso di mancata ricezione dell’email verifica nella cartella spam. Se non hai ricevuto l’email o l’SMS, è possibile contattare telefonicamente il servizio di assistenza dedicato, al numero 02.8898.7005, attivo dal Lunedì al Venerdì dalle ore 9:00 alle 18:00.(Costo di una chiamata nazionale tariffata a seconda del profilo del proprio operatore telefonico)',
    description: 'text of disclaimer',
  },
  disclaimerCountDown: {
    id: 'features.changePhoneNumber.disclaimerCountDown',
    defaultMessage: 'I codici scadranno tra: ',
    description: 'text of disclaimer',
  },
  titleSummaryChangePhoneNumber: {
    id: 'features.changePhoneNumber.titleSummarychangePhoneNumber',
    defaultMessage: 'Nuovo numero di cellulare',
    description: 'Title of step 3 of change phone number',
  },
  disclaimerSummaryChangePhoneNumber: {
    id: 'features.changePhoneNumber.disclaimerSummaryChangePhoneNumber',
    defaultMessage:
      'Si avvisa che dopo la conferma del numero inserito, sarà necessario firmare digitalmente la richiesta per rendere effettiva la modifica.',
    description: 'Disclaimer of step 3 of change phone number',
  },
  disclaimerPhoneNumberSigned: {
    id: 'features.changePhoneNumber.disclaimerPhoneNumberSigned',
    defaultMessage:
      'Una volta firmato il documento di modifica, non sarà possibile effettuare ulteriori richieste nei 5 giorni successivi',
    description: 'Disclaimer of step 3 of change email',
  },
  changePhoneNumberConfirmButton: {
    id: 'features.changePhoneNumber.changePhoneNumberConfirmButton',
    defaultMessage: 'Conferma',
    description: 'Label of the confirmation change phone number button',
  },
  errorInvalidPhoneNumberFormat: {
    id: 'features.changePhoneNumber.errorInvalidPhoneNumberFormat',
    defaultMessage:
      'Numero di cellulare non corretto. Si prega di controllare.',
    description: 'Error invalid phone number format ',
  },
  errorPhoneNumbersNotMatching: {
    id: 'features.changePhoneNumber.errorPhoneNumbersNotMatching',
    defaultMessage: 'Attenzione, i dati inseriti non corrispondono',
    description: 'Error phone numbers not matching',
  },
  errorPhoneNumberNotUsable: {
    id: 'features.changePhoneNumber.errorPhoneNumberNotUsable',
    defaultMessage:
      'Il numero di cellulare risulta già associato ad un altro contratto My Azimut. Si prega di inserire un altro numero di cellulare',
    description: 'Error phone number already associated',
  },
  errorPhoneNumberAlreadyUsed: {
    id: 'features.changePhoneNumber.errorPhoneNumberAlreadyUsed',
    defaultMessage:
      'Il numero di cellulare inserito coincide con quello precedentemente verificato. Si prega di inserire un altro numero di cellulare.',
    description: 'Error phone number already associated',
  },
  errorWrongCode: {
    id: 'features.changePhoneNumber.errorWrongCode',
    defaultMessage:
      'I codici inseriti per la verifica email e cellulare non sono corretti. Riprova. Tentativi rimasti email: {attemptsEmail} Tentativi rimasti cellulare: {attemptsPhoneNumber}',
    description: 'Error wrong code verification phone number ',
  },
  errorTooManyAttemptsTitle: {
    id: 'features.changePhoneNumber.errorTooManyAttemptsTitle',
    defaultMessage: 'Attenzione!',
    description:
      'Title error too many attempts for dialog phone number verification page ',
  },
  errorTooManyAttemptsMessage: {
    id: 'features.changePhoneNumber.errorTooManyAttemptsMessage',
    defaultMessage:
      'Attenzione! Hai raggiunto il limite di tentativi disponibili per verificare il numero di cellulare inserito. Inserisci nuovamente il numero di cellulare per procedere con la verifica.',
    description:
      'Error message too many attempts for dialog phone number verification page ',
  },
  errorTooManyAttemptsButtonLabel: {
    id: 'features.changePhoneNumber.errorTooManyAttemptsButtonLabel',
    defaultMessage: 'Ok',
    description:
      'Label button error too many attempts for dialog phone number verification page ',
  },
  errorPhoneNumberNotEditable: {
    id: 'features.changePhoneNumber.errorPhoneNumberNotEditable',
    defaultMessage:
      'Non è possibile procedere con la richiesta di modifica del numero di cellulare, perché ci sono dei documenti da firmare.',
    description: 'Error message phone number not editable ',
  },
  errorPhoneNumberNotEditableButtonLabel: {
    id: 'features.changePhoneNumber.errorPhoneNumberNotEditableButtonLabel',
    defaultMessage: 'Ok',
    description: 'Label button error phone number not editable',
  },
  errorPhoneNumberNotEditableAfterFirstFiveDays: {
    id: 'features.changePhoneNumber.errorPhoneNumberNotEditableAfterFirstFiveDays',
    defaultMessage:
      'Non è possibile modificare il numero di cellulare, in quanto è già stato effettuato nei 5 giorni precedenti.',
    description:
      'Error message phone number not editable the first five days after last updating',
  },
  errorPhoneNumberNotEditableEmailVerification: {
    id: 'features.changePhoneNumber.errorPhoneNumberNotEditableEmailVerification',
    defaultMessage:
      'Non è possibile modificare il numero di cellulare, in quanto è in corso la modifica dell’indirizzo email.',
    description:
      'Error message phone number not editable because the email editing is not verified yet',
  },
  expiredOtpCodesError: {
    id: 'features.changePhoneNumber.expiredOtpCodesError',
    defaultMessage:
      'I codici OTP sono scaduti. Si prega di tornare indietro e inserire nuovamente il numero di cellulare',
    description: '',
  },
  wrongOtpCodePhoneError: {
    id: 'features.changePhoneNumber.wrongOtpCodePhoneError',
    defaultMessage:
      'Il codice inserito per la verifica cellulare non è corretto. Riprova. Tentativi rimasti email: {attemptsEmail} Tentativi rimasti cellulare: {attemptsPhoneNumber}',
    description: 'error message showed when the otp code phone go wrong',
  },

  wrongOtpCodeEmailError: {
    id: 'features.changePhoneNumber.wrongOtpCodeEmailError',
    defaultMessage:
      'Il codice inserito per la verifica email non è corretto. Riprova. Tentativi rimasti email: {attemptsEmail} Tentativi rimasti cellulare: {attemptsPhoneNumber}',
    description: 'error message showed when the otp code email go wrong',
  },

  maximumAttemptsAchievedError: {
    id: 'features.changePhoneNumber.maximumAttemptsAchievedError',
    defaultMessage:
      'Hai raggiunto il limite di tentativi disponibili per verificare il numero di cellulare inserito. Inserisci nuovamente il numero di cellulare per procedere con la verifica',
    description: '',
  },
  errorExpiredDocument: {
    id: 'features.changePhoneNumber.errorExpiredDocument',
    defaultMessage:
      'Attenzione! Impossibile procedere con la modifica delle credenziali per documento di identità scaduto.',
    description: 'Error document expired',
  },
});
